<template>
  <div>
    <div class="wrapper-content w-100 position-relative pt-4">
      <div>
        <LmSuperPowerSelectV2 label="Origen de datos" placeholder="Origen de datos" :options="dataOrigin"
          v-model="dataOriginSelected" @input="!isOnEditMode ? inputOriginData() : ''" :defaultValue="dataOriginSelectedDefault" v-show="!isOnEditMode" :help="$t('Origen de datos del listado')"   />
        <div v-if="dataOriginSelected || isOnEditMode">
          <LmTextInput label="Alias" v-model="form.alias" :help="$t('Alias para identificar el formulario en el listado')"  />

          <LmTextInput label="Título del listado" v-model="listBuilderTitleList" :help="$t('Título que se previsualizará en el listado')"  />

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isSearch=!isSearch">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isSearch ? 'angle-down' : 'angle-up'" /> Búsqueda inicial
            </div>
          </div>
          <div class=" border border-1 border-secondary p-4" v-show="isSearch">

            <div class="mt-2">
              <LmTextInput label="Búsqueda inicial" v-model="form.gqlVariables.q" :help="$t('Prefiltrado con búsqueda')" />
              <LmTextInput label="Meta search" v-model="form.metaSearch" :help="$t('Filtrado en base a los datos de sesión del usuario')" />
              <LmSuperPowerSelectV2 label="Ordenar por" placeholder="_score" :options="dataSort"
          v-model="dataSortSelected" @input="inputSortData" :defaultValue="dataSortSelected" :help="$t('Orden inicial')"  />

              <LmButton type="button" buttonClass="btn-primary" value="Agregar búsqueda"
                lmButtonRootWrapperClass="d-inline-block mr-1 mt-2 mb-0" lmButtonWrapperClass="col"
                @click.native="addSearch" />
            </div>
          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isColumns=!isColumns">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isColumns ? 'angle-down' : 'angle-up'" /> Columnas
            </div>
          </div>
          <div class=" border border-1 border-secondary p-4" v-if="isColumns">

            <div v-for="(item, index) in form.items" :key="index">
              <input type="checkbox" :value="item.name" :id="'col-'+index" name="itemsColumns"
                v-model="form.searchOnFieldsToSelected" checked class="mr-2"><label
                :for="'col-'+index">{{ item.name }}</label>
            </div>

            <LmButton type="button" buttonClass="btn-primary" value="Aplicar columnas"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-0" lmButtonWrapperClass="col"
              @click.native="addColumns" />

          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isButtons=!isButtons">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isButtons ? 'angle-down' : 'angle-up'" /> Botones - {{ form.buttonLinks.length }}
            </div>
          </div>
          <div class=" border border-1 border-secondary p-4" v-if="isButtons">
            <LmTextInput v-model="buttons.value" label="Value" placeholder="Nuevo formulario" :help="getHelp('lmButtonLink', 'value')" />

            <LmTextInput v-model="buttons.to" label="To" placeholder="/listbuilderui/" :help="getHelp('lmButtonLink', 'to')" />

            <LmTextInput v-model="buttons.endpointToValidateVisibility" label="Endpoint to validate visibility" placeholder="Path" :help="getHelp('lmButtonLink', 'endpointToValidateVisibility')" />

            <label for="buttons-show" v-text="getHelp('lmButtonLink', 'show')"  />
            <b-form-checkbox
            id="buttons-show"
            v-model="buttons.show"
            :value="true"
            :unchecked-value="false"
            >
              Show
            </b-form-checkbox>

            <label for="buttons-disabled" v-text="getHelp('lmButtonLink', 'disabled')" class="mt-2" />
            <b-form-checkbox
            id="buttons-disabled"
            v-model="buttons.disabled"
            :value="true"
            :unchecked-value="false"
            >
              Disabled
            </b-form-checkbox>

            <label for="buttons-color" class="mt-2">Color</label>

            <swatches
            id="buttons-color"
      v-model="colorButton"
      :swatches="swatches"
      :trigger-style="{ width: '36px', height: '36px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      :swatch-style="{ width: '36px', height: '36px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      popover-to="left"
      class="d-block"
    ></swatches>

            <LmButton type="button" buttonClass="btn-primary" value="Agregar botón"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-3" lmButtonWrapperClass="col"
              @click.native="addButonLink" />

            <div v-for="(item, index) in form.buttonLinks" :key="index">

              <LmButton type="button" :buttonClass="item.buttonClass" :value="item.value"
                lmButtonRootWrapperClass="d-inline-block  mt-3 mb-0" lmButtonWrapperClass="col" /> <span
                class="mx-2">|</span>
              <font-awesome-icon icon="trash" @click="deleteButtons(index)" />
            </div>
          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isPages=!isPages">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isPages ? 'angle-down' : 'angle-up'" /> Paginado - {{ form.page }} - {{ form.perpage }}
            </div>
          </div>

          <div class=" border border-1 border-secondary p-4" v-if="isPages">
            <LmTextInput label="Page" v-model="form.page" :help="$t('Número de página que iniciará el listado')"   />
            <LmTextInput label="Per Page" v-model="form.perpage" :help="$t('Cantidad de items a listar')"   />
            <LmButton type="button" buttonClass="btn-primary" value="Aplicar pages"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-0" lmButtonWrapperClass="col"
              @click.native="addPages" />
          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isActions=!isActions">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isActions ? 'angle-down' : 'angle-up'" /> Acciones -
              {{ (form.lmPathActions.length + form.lmModalActions.length) }}
            </div>
          </div>

          <div class=" border border-1 border-secondary p-4" v-if="isActions">

           <p> Types:</p>
            <b-form-radio-group
              v-model="form.action"
              :options="typeAction"
              class="mb-3"
              value-field="item"
              text-field="name"
              disabled-field="notEnabled"
            ></b-form-radio-group>

            <template v-if="form.action.lmPathActions === true">
            <LmTextInput ref="to" v-model="action.to" label="to" :help="getHelp('lmPathActions', 'to')" />

            <LmTextInput ref="tooltip" v-model="action.tooltip" label="tooltip" placeholder="Editar" :help="getHelp('lmPathActions', 'tooltip')" />

            <LmTextInput ref="font awesome icon" v-model="action.fontAwesomeIcon" label="fontAwesomeIcon" :help="getHelp('lmPathActions', 'fontAwesomeIcon')"
              placeholder="edit" />
              Icons: <a href="https://fontawesome.com/icons?d=gallery" target="_blank" class="mt-0 mb-4 d-block">https://fontawesome.com/icons?d=gallery</a>
            </template>

            <div v-if="form.action.lmModalActions === true">
              <LmTextInput ref="modalEndpoint" v-model="modal.endpoint" placeholder="Path"  label="endpoint" :help="getHelp('lmModalActionsArgument', 'endpoint')" />
              <LmSelect v-model="modal.requestMethod" label="request method" :options="{
                  disabledOption: 'Seleccione una opción',
                  content: [
                    { value: 'POST', text: 'POST' },
                    { value: 'PUT', text: 'PUT' },
                    { value: 'DELETE', text: 'DELETE' }
                  ]
                }"
                :help="getHelp('lmModalActionsArgument', 'requestMethod')"
                />
              <LmNumberInput ref="modalDelayAfterSubmit" v-model="modal.delayAfterSubmit" placeholder="delay"  label="delay after submit" :help="getHelp('lmModalActionsArgument', 'delayAfterSubmit')" />
              <LmTextInput ref="modalTitle" v-model="modal.title" placeholder="Title modal"  label="title" :help="getHelp('lmModalActionsArgument', 'title')" />
              <LmTextInput ref="modalTooltip" v-model="modal.tooltip" placeholder="Tooltip icon" label="tooltip" :help="getHelp('lmModalActionsArgument', 'tooltip')" />
              <LmEditor ref="modalMessage" @onUpdate="modal.message = $event" :contentProps="modal.message" placeholder="Messaage" label="message" :activeTable="false" :help="getHelp('lmModalActionsArgument', 'message')" />
              <input type="checkbox" id="isComment" name="isComment"
                v-model="modal.isComment" class="mb-4 mt-2">
              <label for="isComment" class="ml-1">isComment ( textarea )</label>
              <div v-if="modal.isComment" class=" px-3">
                <LmTextInput ref="modalComment" v-model="modal.labelComment" placeholder="Label textarea" label="Label comment" :help="getHelp('lmModalActionsArgument', 'labelComment')"/>
                <input type="checkbox" id="isCommentValidationRequired" name="isCommentValidationRequired"
                  v-model="modal.isCommentValidationRequired" class="mb-4 mt-2">
                <label for="isCommentValidationRequired" class="ml-1">Required</label>
              </div>
              <LmTextInput ref="modalFontAwesomeIcon" v-model="modal.fontAwesomeIcon" label="fontAwesomeIcon"
              placeholder="window-restore" :help="getHelp('lmModalActionsArgument', 'fontAwesomeIcon')" />
              icons: <a href="https://fontawesome.com/icons?d=gallery" target="_blank" class="mt-0 mb-4 d-block">https://fontawesome.com/icons?d=gallery</a>
              <!-- <LmTextInput ref="Modalcondition" v-model="modal.condition" label="condition" /> -->
              <div class="col mb-3" v-if="false">
              <div class="row ">
              <LmTextInput ref="modalLeftHandSideValue" placeholder="Left value"   label="left hand side value" />
              <LmSelect label="operator" class="mx-3" :options="{
                  content: [
                    { value: '===', text: '===' },
                    { value: '!==', text: '!==' },
                  ]
                }" />
              <LmTextInput ref="modalRightHandSideValue" placeholder="Right value"   label="right hand side value" />
              </div>
        </div>
      </div>

            <LmButton type="button" buttonClass="btn-primary" value="Agregar action"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-2 mb-0" lmButtonWrapperClass="col"
              @click.native="addActions" />

            <div class="mt-3 mb-2 ">
              <div v-for="(item, index) in form.lmPathActions" :key="'path-'+index" >
                <b-button-group class="mt-2">
                  <b-button variant="outline-primary"><font-awesome-icon :icon="item.fontAwesomeIcon" /> {{ item.tooltip }}</b-button>
                  <b-button variant="outline-secondary" @click="deleteActions(index,'path')"><font-awesome-icon icon="trash" /></b-button>
                </b-button-group>
              </div>
              <div v-for="(item, index) in form.lmModalActions" :key="'modal-'+index">
                <b-button-group class="mt-2">
                 <b-button variant="outline-primary"><font-awesome-icon :icon="item.fontAwesomeIcon" /> {{ item.tooltip }}</b-button>
                 <b-button variant="outline-secondary" @click="deleteActions(index,'modal')"><font-awesome-icon icon="trash" /></b-button>
                </b-button-group>
              </div>
            </div>
          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isMode=!isMode">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isMode ? 'angle-down' : 'angle-up'" /> Modo
            </div>
          </div>

          <div class=" border border-1 border-secondary p-4" v-if="isMode">
            <b-form-radio-group
              v-model="form.mode"
              :options="modes"
              class="mb-2"
              value-field="item"
              text-field="name"
              disabled-field="notEnabled"
            ></b-form-radio-group>
          </div>

          <LmButton type="submit" buttonClass="btn-primary" :value="$t('Save')"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-2" lmButtonWrapperClass="col"
            @click.native="submit" :isProcessing="isProcessing"
            :disabled="isDisabledByUserPrivileges()" />
          <p
            v-if="isDisabledByUserPrivileges()"
            class="font-italic text-danger"
          >
            Lo sentimos, no tiene permisos para guardar los cambios.
          </p>

            <div class="border d-block mt-3 p-3 mb-0 " v-if="this.currentID">
            <router-link :to="{ path: '/listbuilder/view/'+ this.currentID }" class="d-block text-monospace">
            👉 Ver el último listado cargado
            </router-link>
            <router-link :to="{ path: '/listbuilder/view/' + this.listadoID }" class="d-block mt-1 text-monospace">
              <font-awesome-icon icon="list-alt" class="" /> Listado de Listados
            </router-link>
            </div>

        </div>
      </div>
    </div>

    <div class="bg-primary text-light  py-2 mt-4 mb-4">
      <div class="wrapper-content w-100 position-relative my-1">
        <font-awesome-icon icon="list" class="mr-1" /> Preview del listado
      </div>
    </div>

    <LmListV2 v-if="dataOriginSelected" ref="LmListV2" :isGraphql="isGraphql"
      :gqlField="form.gqlField" :gqlVariables="form.gqlVariables" :gqlQuery="form.gqlQuery"
      :searchOnFieldsSelected="form.searchOnFieldsSelected"
      :searchOnFieldsToSelected="form.searchOnFieldsToSelected"
      :mode="form.mode"
      :allAvailableFields="form.fields"
      :isOnEditMode="true"
      :key="key"
      :listBuilderTitleList="listBuilderTitleList"
      :listBuilderButtons="listBuilderButtons" />

    <LmError v-if="!dataOriginSelected" title="Seleccione el origen de datos"
      subtitle="Comience seleccionando el origen de datos para previsualizar la tabla" />

  </div>
</template>

<script>
import gql from 'graphql-tag'
import _ from 'lodash'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import commonsApi from '@/api/commons'
import LmListV2 from '@/components/LmListV2.vue'
import LmTextInput from '@/components/form/elements/LmTextInput.vue'
import LmNumberInput from '@/components/form/elements/LmNumberInput.vue'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'
import LmError from '@/components/LmError.vue'
import LmButton from '@/components/form/elements/LmButton.vue'
import lmToasts from '@/mixins/lmToasts.js'
import LmSelect from '@/components/form/elements/LmSelect.vue'
import LmEditor from '@/components/LmEditor.vue'
import LmTextArea from '@/components/form/elements/LmTextArea.vue'

import { checkUserPermissions } from '@/helpers/userPermissions'

export default {
  mixins: [lmToasts],
  components: {
    LmListV2,
    LmTextInput,
    LmNumberInput,
    LmSuperPowerSelectV2,
    LmError,
    LmButton,
    Swatches,
    LmSelect,
    LmEditor,
    LmTextArea
  },
  props: {
    isGraphql: {
      type: Boolean,
      default: false
    },
    gqlQuery: {
      type: String,
      default: ''
    },
    gqlSchema: {
      type: String,
      default: ''
    },
    gqlField: {
      type: String,
      default: ''
    },
    gqlVariables: {
      type: Object
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataOrigin: [],
      dataOriginSelected: '',
      dataOriginSelectedDefault: '',
      dataSchemaGraphql: '',
      dataSort: [],
      isLoading: false,
      isActions: false,
      isSearch: false,
      isColumns: false,
      isButtons: false,
      isPages: false,
      isMode: false,
      isProcessing: false,
      help: {},
      currentID: '',
      listadoID: '600f360aed518edeaa897095',
      dataSortSelected: {},
      defaultDataSortSelected: '',
      arrayEmplyItems: [],
      swatches: [{ color: '#007bff' }, { color: '#6c757d' }, { color: '#17a2b8' }, { color: '#28a745' }, { color: '#ffc107' }, { color: '#dc3545' }, { color: '#343a40' }],
      colorButton: '#17a2b8',
      buttons: {
        value: '',
        to: '',
        endpointToValidateVisibility: '',
        show: true,
        disabled: false,
        buttonClass: ''
      },
      typeAction: [
        { item: { lmPathActions: true, lmModalActions: false }, name: 'Path' },
        { item: { lmPathActions: false, lmModalActions: true }, name: 'Modal' }
      ],
      action: {
        to: '/listbuilder/edit/:_id',
        tooltip: '',
        fontAwesomeIcon: ''
      },
      modal: {
        endpoint: '',
        title: '',
        message: '',
        isComment: false,
        isCommentValidationRequired: false,
        labelComment: '',
        successMessage: '',
        fontAwesomeIcon: '',
        tooltip: '',
        requestMethod: '',
        delayAfterSubmit: 0
        // condition: {}
      },
      count: 0,
      key: 0,
      modes: [
        { item: { table: true, map: false }, name: 'Listado' },
        { item: { table: false, map: true }, name: 'Mapa' }
      ],
      form: {
        alias: '',
        titleList: '',
        gqlField: '',
        gqlQuery: '',
        gqlVariables: {
          q: '*',
          sort: '_score',
          page: 1
        },
        metaSearch: '*',
        lmPathActions: [],
        lmModalActions: [],
        searchOnFieldsSelected: [],
        searchOnFieldsToSelected: [],
        allAvailableFields: [],
        fields: [],
        newFields: [],
        items: {},
        buttonLinks: [],
        page: 1,
        perpage: 10,
        mode: {
          table: true,
          map: false
        },
        action: {
          lmPathActions: true,
          lmModalActions: false
        }
      },
      listBuilderTitleList: '',
      listBuilderButtons: [],
      viewPermissions: {
        allowAccess: process?.env?.VUE_APP_LISTBUILDER_ALLOW_PERMISSIONS.split(',') || [],
        allowCreate: process?.env?.VUE_APP_LISTBUILDER_ALLOW_PERMISSIONS.split(',') || [],
        allowUpdate: process?.env?.VUE_APP_LISTBUILDER_ALLOW_PERMISSIONS.split(',') || []
      },
      userPrivileges: {}
    }
  },
  computed: {
    computedButtonClass: function () {
      let buttonClass = ''
      if (this.colorButton === '#007bff') buttonClass = 'btn-primary'
      if (this.colorButton === '#6c757d') buttonClass = 'btn-secondary'
      if (this.colorButton === '#17a2b8') buttonClass = 'btn-info'
      if (this.colorButton === '#28a745') buttonClass = 'btn-success'
      if (this.colorButton === '#ffc107') buttonClass = 'btn-warning'
      if (this.colorButton === '#dc3545') buttonClass = 'btn-danger'
      if (this.colorButton === '#343a40') buttonClass = 'btn-dark'
      return buttonClass
    }
  },
  methods: {
    addButtonClass (color) {
      if (color === '#007bff') color = 'btn-primary'
      if (color === '#6c757d') color = 'btn-secondary'
      if (color === '#17a2b8') color = 'btn-info'
      if (color === '#28a745') color = 'btn-success'
      if (color === '#ffc107') color = 'btn-warning'
      if (color === '#dc3545') color = 'btn-danger'
      if (color === '#343a40') color = 'btn-dark'
      return color
    },
    isDisabledByUserPrivileges () {
      // Crear
      if (!this.userPrivileges.allowCreate && !this.isOnEditMode) {
        return true
      }
      // Actualizar
      if (!this.userPrivileges.allowUpdate && this.isOnEditMode) {
        return true
      }
      return false
    },
    inputSortData () {
      let sort = this.dataSortSelected?.name
      this.form.gqlVariables.sort = sort
      this.key++
      this.initialOriginData()
    },
    inputOriginData () {
      this.form.alias = ''
      if (!this.isOnEditMode) this.form.titleList = ''
      this.form.lmPathActions = []
      this.form.lmModalActions = []
      this.form.buttonLinks = []
      this.form.page = 1
      this.form.perpage = 10
      if (!this.isOnEditMode) this.form.gqlVariables.q = '*'
      if (!this.isOnEditMode) this.form.metaSearch = '*'
      if (!this.isOnEditMode) this.form.gqlVariables.sort = '_score'
      this.form.fields = []
      this.count = 0
      this.key++
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({})
      }
      this.initialOriginData('inputOriginData')
    },
    addPages () {
      this.key++
      this.initialOriginData()
    },
    addButonLink () {
      if (this.buttons?.to && this.buttons?.value) {
        this.buttons.buttonClass = this.computedButtonClass
        this.form.buttonLinks.push({ ...this.buttons })
        this.buttons.to = ''
        this.buttons.value = ''
        this.buttons.endpointToValidateVisibility = ''
        this.buttons.show = true
        this.buttons.disabled = false
        this.key++
        this.initialOriginData()
      }
    },
    deleteButtons (index) {
      this.form.buttonLinks.splice(index, 1)
      this.key++
      this.initialOriginData()
    },
    addColumns () {
      let newOrderedArray = []
      let searchOnFieldsToSelected = this.form.searchOnFieldsToSelected
      _.forEach(this.form.items, function (value, key) {
        if (searchOnFieldsToSelected.includes(value.name)) newOrderedArray.push(value.name)
      })
      this.form.searchOnFieldsToSelected = newOrderedArray
      this.key++
      this.initialOriginData('addColumns')
    },
    addSearch () {
      this.form.gqlVariables.q = this.form.gqlVariables?.q ? this.form.gqlVariables.q : '*'
      this.form.metaSearch = this.form?.metaSearch ? this.form.metaSearch : '*'
      this.key++
      this.initialOriginData()
    },
    async addActions () {
      if (this.form.action.lmPathActions === true) {
        if (this.action?.to && this.action?.tooltip && this.action?.fontAwesomeIcon) {
          this.form.lmPathActions.push({ ...this.action })
          this.action.tooltip = ''
          this.action.fontAwesomeIcon = ''
          this.key++
          this.initialOriginData()
        }
      }
      if (this.form.action.lmModalActions === true) {
        if (this.modal?.endpoint && this.modal?.title && this.modal?.tooltip && this.modal?.fontAwesomeIcon) {
          this.modal.delayAfterSubmit = parseInt(this.modal.delayAfterSubmit)
          this.form.lmModalActions.push({ ...this.modal })
          this.modal.endpoint = ''
          this.modal.title = ''
          this.modal.tooltip = ''
          this.$refs.modalMessage.editor.clearContent()
          this.modal.isComment = false
          this.modal.isCommentValidationRequired = false
          this.modal.labelComment = ''
          this.modal.successMessage = ''
          this.modal.fontAwesomeIcon = ''
          this.modal.requestMethod = ''
          this.modal.delayAfterSubmit = 0
          this.key++
          this.initialOriginData()
        }
      }
    },
    deleteActions (index, type) {
      if (type === 'path') this.form.lmPathActions.splice(index, 1)
      if (type === 'modal') this.form.lmModalActions.splice(index, 1)
      this.key++
      this.initialOriginData()
    },
    async submit () {
      try {
        if (this.isOnEditMode) {
          this.initialOriginData()
          const response = await commonsApi.axiosPutWrapper(`listbuilder/${this.$route.params.id}`, this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/listbuilder/view/${this.currentID}`, 'Puedes ver el listado aquí', 'Se guardó exitosamente')
        } else {
          this.isProcessing = true
          const response = await commonsApi.axiosPostWrapper('listbuilder/create', this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/listbuilder/view/${this.currentID}`, 'Puedes ver el listado aquí', 'Se guardó exitosamente')
        }
      } finally {
        this.isProcessing = false
      }
    },
    getHelpData () {
      let lmModalActionsArgumentToHelp = ''
      let lmPathActionsToHelp = ''
      let lmButtonLinkArgumentToHelp = ''

      // usado para obtener las descripciones de los campos en los resolvers
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name === 'lmModalActionsArgument') {
          lmModalActionsArgumentToHelp = value.type.ofType.inputFields
        }
      })
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name === 'lmPathActionArgument') {
          lmPathActionsToHelp = value.type.ofType.inputFields
        }
      })
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name === 'lmButtonLinkArgument') {
          lmButtonLinkArgumentToHelp = value.type.ofType.inputFields
        }
      })
      this.help.lmModalActionsArgument = lmModalActionsArgumentToHelp
      this.help.lmPathActions = lmPathActionsToHelp
      this.help.lmButtonLink = lmButtonLinkArgumentToHelp
    },
    getHelp (resolver, fieldname) {
      return this.$t(this.help[resolver]?.find(field => field.name === fieldname).description)
    },
    replaceQuote (val) {
      return JSON.stringify(val).replace(/"([^"]+)":/g, '$1:')
    },
    initialOriginData (loadFromMethod) {
      let sort = ''
      let items = ''
      let item = ''
      let fieldSelected = []
      this.arrayEmplyItems = []
      // get name of field sort
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name.substr(-8) === 'SortEnum') {
          sort = value.type.ofType.name
        }
      })
      this.getHelpData()
      const table = _.filter(this.dataOriginSelected.fields, ['name', 'table'])
      items = _.filter(table[0]?.type?.fields, ['name', 'items'])
      items = items[0]?.type?.ofType?.fields
      this.form.items = items
      let emplyItems = {}
      _.forEach(items, function (value, key) {
        item += value.name + ' '
        emplyItems[value.name] = ' '
        fieldSelected.push(value.name)
      })
      this.arrayEmplyItems.push(emplyItems)
      items = item
      if (loadFromMethod === 'addColumns') {
        items = this.form.searchOnFieldsToSelected.toString()
        items = items.replaceAll(',', ' ')
      }
      if (loadFromMethod === 'inputOriginData') {
        this.form.searchOnFieldsSelected = fieldSelected
        this.form.searchOnFieldsToSelected = fieldSelected
        this.form.gqlVariables.q = '*'
        this.form.metaSearch = '*'
      }
      let lmPathActions = this.replaceQuote(this.form.lmPathActions)
      let lmModalActions = this.replaceQuote(this.form.lmModalActions)
      let buttonLinks = this.replaceQuote(this.form.buttonLinks)
      this.form.gqlField = this.dataOriginSelected.name
      let enumDataSort = this?.dataOriginSelected.args[2]?.type?.ofType?.enumValues
      let dataSort = []
      _.forEach(enumDataSort, function (value, key) {
        dataSort.push({ id: value.name, name: value.name })
      })
      if (!this.isOnEditMode) this.dataSort = enumDataSort
      if (this.count === 1 && this.isOnEditMode) this.dataSort = dataSort
      if (this.count === 1 && !this.isOnEditMode) {
        this.form.allAvailableFields = this.form.fields
      }
      this.form.newFields = this.form.fields
      const valuesToRemove = this.form.searchOnFieldsToSelected
      const filteredItems = this.form.newFields.filter(item => valuesToRemove.includes(item.key))
      this.form.newFields = filteredItems
      if (this.form.searchOnFieldsToSelected.length > this.form.newFields.length && this.form.newFields.length > 0) {
        const valuesToAdd = this.form.searchOnFieldsToSelected
        const filteredItems = this.form.allAvailableFields.filter(item => valuesToAdd.includes(item.key))
        //
        this.form.newFields = filteredItems
      }
      this.form.titleList = this.listBuilderTitleList
      // queryGraphql
      this.form.gqlQuery = `query($page:Int, $q:String, $sort:[${sort}]) {
      ${this.form.gqlField}(
          titleList: ${this?.form?.titleList ? '"' + this?.form?.titleList + '"' : '" "'}
          q: $q
          perPage: ${this?.form?.perpage ? this?.form?.perpage : 10}
          page: $page
          sort: $sort
          metaSearch: "${this?.form?.metaSearch}"
          opts: {
            lenient: true
          }
          lmPathActions: ${this?.form?.lmPathActions.length > 0 ? lmPathActions : '[]'}
          lmModalActions: ${this?.form?.lmModalActions.length > 0 ? lmModalActions : '[]'}
          buttonLinks: ${this?.form?.buttonLinks.length > 0 ? buttonLinks : '[]'}

          ) {
          count
          searcher
          tableItemsTotal
          titleList
          table {
            items {
              ${this.form?.searchOnFieldsToSelected}
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`
      this.form.gqlVariables = {
        q: this?.form?.gqlVariables.q,
        sort: this.form?.gqlVariables?.sort ? this?.form?.gqlVariables?.sort : '_score',
        page: this?.form?.page ? this?.form?.page : 1
      }
      this.count++
    },
    async getListValues () {
      try {
        this.isDataProcessing = true
        const endPoint = await commonsApi.axiosGetWrapper(`listbuilder/${this.$route.params.id}`)
        this.form.gqlQuery = endPoint.data.gqlQuery
        this.dataOriginSelected = this.dataOrigin.filter(dataOrigin => dataOrigin.name === `${endPoint.data.gqlField}`)
        this.dataOriginSelected = this.dataOriginSelected
        this.dataOriginSelectedDefault = this.dataOriginSelected[0]
        this.form.gqlVariables = endPoint.data.gqlVariables
        this.dataSortSelected = { id: endPoint.data.gqlVariables.sort, name: endPoint.data.gqlVariables.sort }
        this.form.titleList = endPoint.data.titleList
        this.form.alias = endPoint.data.alias
        this.form.gqlField = endPoint.data.gqlField
        this.form.buttonLinks = endPoint.data.buttonLinks
        this.form.lmPathActions = endPoint.data.lmPathActions
        this.form.lmModalActions = endPoint.data.lmModalActions
        this.form.searchOnFieldsSelected = endPoint.data.searchOnFieldsSelected
        this.form.searchOnFieldsToSelected = endPoint.data.searchOnFieldsToSelected
        this.form.items = endPoint.data.items
        this.form.fields = endPoint.data.fields
        this.form.allAvailableFields = endPoint.data.allAvailableFields
        this.form.mode = endPoint.data.mode
        this.listBuilderTitleList = endPoint.data.titleList
        this.listBuilderButtons = endPoint.data.buttonLinks
      } catch (error) {
        console.log(error)
      } finally {
        this.isDataProcessing = false
      }
    }
  },
  created () {
    // Check user permissions
    this.userPrivileges = checkUserPermissions(this.viewPermissions)
    if (!this.userPrivileges.allowAccess) {
      this.$router.push('/')
    }
  },
  async mounted () {
    if (this.isGraphql) {
      try {
        this.dataSchemaGraphql = await this.$apollo.query({ query: gql`${this.gqlSchema}` })
        let initialDataOrigin = []
        // get origin data and args
        _.forEach(this.dataSchemaGraphql.data.__schema.queryType.fields, function (value, key) {
          initialDataOrigin.push({
            id: key,
            args: value.args,
            name: value.name,
            fields: value.type.fields
          })
        })
        this.dataOrigin = initialDataOrigin
        if (this.isOnEditMode) {
          this.getListValues()
        }
      } catch (e) {
        console.log('graphQlAllErrors:', JSON.stringify(e))
        console.log('graphQlNetworkError:', JSON.stringify(e.networkError))
        console.log('graphQlErrors:', JSON.stringify(e.graphQLErrors))
      }
    }
  }
}
</script>
<style></style>
